exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.conecta-atenciones__base .estilo-grilla,\n#gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n.conecta-atenciones__base\n  .estilo-grilla\n  .ag-pinned-left-header\n  .ag-header-select-all.ag-hidden {\n  display: block !important;\n}\n.conecta-atenciones__base .estilo-grilla div[col-id='checked'] {\n  pointer-events: all !important;\n}\n", ""]);

// exports
